import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { fetchAllTeams } from '../../views/StaffPage/Discords/StaffDiscordApi';
import { Typography, Grid, Box } from '@mui/material';
import DiscordTeamCard from './components/DiscordTeamCard.js';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { HandshakeOutlined } from '@mui/icons-material';
import Button from 'components/CustomButtons/Button.js';

export default function CommunityContent() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    data: teams = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ['modTeams'],
    queryFn: fetchAllTeams,
  });

  const publishedTeams = teams.filter((team) => team.published);

  const handleGetInvolvedClick = () => {
    navigate('/get-involved?t=community');
  };

  return (
    <div>
      <Box mb={4}>
        <Typography variant="h6" color="primary" gutterBottom>
          {t('search.navPills.community.getInTouch')}
        </Typography>
        <Typography variant="body1" paragraph>
          {t('search.navPills.community.getInTouchDescription')}
        </Typography>
        <div style={{ marginTop: '10px' }}>
          <Link to="/get-involved?t=community">
            <Button color="outlined" size="sm">
              <HandshakeOutlined style={{ marginRight: '5px', color: 'inherit' }} />
              {t('landing.work')}
            </Button>
          </Link>
        </div>
      </Box>

      {isLoading ? (
        <Typography>Loading...</Typography>
      ) : error !== null ? (
        <Typography color="error">{t('search.navPills.community.errorLoading')}</Typography>
      ) : publishedTeams.length === 0 ? (
        <Typography>{t('search.navPills.community.noTeams')}</Typography>
      ) : (
        <Grid container spacing={3}>
          {publishedTeams.map((team) => (
            <Grid item xs={12} key={team.id}>
              <DiscordTeamCard team={team} />
            </Grid>
          ))}
        </Grid>
      )}
    </div>
  );
}
